/**
 * Format a lot asking/sale amount together with its published description.
 * Without an amount, numeric descriptions retain their published formatting
 * with the society currency; other descriptions are left unchanged.
 */
export function formatLotPrice(
  price: number | null | undefined,
  desc: string | null | undefined,
  currencySymbol: string,
): string {
  const trimmedDesc = desc?.trim();
  if (price != null && !Number.isNaN(price)) {
    const amount = Math.abs(price).toLocaleString('en-AU');
    const formattedPrice = `${price < 0 ? '-' : ''}${currencySymbol}${amount}`;
    return trimmedDesc ? `${formattedPrice} ${trimmedDesc}` : formattedPrice;
  }
  if (trimmedDesc) {
    const numericDescription =
      /^[+-]?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(trimmedDesc);
    if (!numericDescription) return trimmedDesc;
    const sign = /^[+-]/.test(trimmedDesc) ? trimmedDesc.charAt(0) : '';
    return `${sign}${currencySymbol}${trimmedDesc.slice(sign.length)}`;
  }
  return '';
}
